/** Successful submit from the auto contact popup — do not auto-open again (survives refresh). */
export const CONTACT_POPUP_SUBMITTED_KEY = 'humpro-contact-popup-submitted';

/** Auto popup was already shown this tab session — do not show again on refresh. */
export const CONTACT_POPUP_SESSION_KEY = 'humpro-contact-popup-shown-session';

export function hasSubmittedContactPopup() {
  try {
    return window.localStorage.getItem(CONTACT_POPUP_SUBMITTED_KEY) === '1';
  } catch {
    return false;
  }
}

export function hasShownContactPopupThisSession() {
  try {
    return window.sessionStorage.getItem(CONTACT_POPUP_SESSION_KEY) === '1';
  } catch {
    return false;
  }
}

export function markContactPopupSubmitted() {
  try {
    window.localStorage.setItem(CONTACT_POPUP_SUBMITTED_KEY, '1');
    window.sessionStorage.setItem(CONTACT_POPUP_SESSION_KEY, '1');
  } catch {
    /* private mode / blocked storage */
  }
}

export function markContactPopupShownThisSession() {
  try {
    window.sessionStorage.setItem(CONTACT_POPUP_SESSION_KEY, '1');
  } catch {
    /* private mode */
  }
}
